import React, { useEffect } from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import SaveIcon from '@material-ui/icons/SaveAlt';
import { connect } from 'react-redux';
import P404 from './P404';
import { getFileList } from '../redux/actions';
import { staticsUrl } from '../config';
import iconZip from '../images/icon-zip.png';
import iconExcel from '../images/icon-excel.png';
import iconImage from '../images/icon-image.png';
import iconPdf from '../images/icon-pdf.png';
import iconWord from '../images/icon-word.png';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: '0.75em 1em',
    textDecoration: 'none',
    width: 'calc(25% - 10px)',
    color: theme.palette.text.primary,
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: '0.85em',
    margin: '0 10px 10px 0',
    '& > a': {
      color: theme.palette.text.primary,
      display: 'inline-block',
      width: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      verticalAlign: 'middle',
      textDecoration: 'none',
    },
    '& svg': {
      marginRight: 10,
      verticalAlign: 'middle',
    },
    '& img': {
      width: 24,
      height: 'auto',
      verticalAlign: 'middle',
      marginRight: 10,
    },
  },
  '@media(max-width: 850px)': {
    paper: {
      width: 'calc(33.33333% - 10px)',
    }
  },
  '@media(max-width: 600px)': {
    paper: {
      width: 'calc(50% - 10px)',
    }
  },
  '@media(max-width: 500px)': {
    paper: {
      width: '100%',
      margin: '0 0 10px 0',
    }
  }
}));

function Downloads(props) {
  const classes = useStyles();

  useEffect(() => {
    if (!props.files.id || props.files.id !== props.course.id) {
      props.course.id !== undefined && props.getFileList(props.course.id);
    }
    // eslint-disable-next-line
  }, []);

  const renderFiles = () => {
    if (!props.files.id || props.files.id !== props.course.id) return;
    return props.files.downloads.map(({ id, url, name, type }) => {
      let icon;
      switch (type) {
        case 'pdf':
          icon = <img src={iconPdf} alt="pdf" />;
          break;
        case 'doc':
          icon = <img src={iconWord} alt="docx" />;
          break;
        case 'docx':
          icon = <img src={iconWord} alt="docx" />;
          break;
        case 'xls':
          icon = <img src={iconExcel} alt="xls" />;
          break;
        case 'jpg':
          icon = <img src={iconImage} alt="jpg" />;
          break;
        case 'png':
          icon = <img src={iconImage} alt="png" />;
          break;
        case 'gif':
          icon = <img src={iconImage} alt="gif" />;
          break;
        case 'zip':
          icon = <img src={iconZip} alt="zip" />;
          break;
        default:
          icon = <SaveIcon />;
      }
      return (
        <Paper elevation={1} className={classes.paper} key={id}>
          <a href={staticsUrl + url} title={name}>
            {icon}
            {name}
          </a>
        </Paper>
      );
    });
  }

  if (props.course.id === undefined) {
    return <P404 />
  }

  return (
    <div className={classes.wrap}>
      {renderFiles()}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    files: state.files,
    course: state.course,
  };
}

export default connect(mapStateToProps, { getFileList })(Downloads);
